import {
	CDIFilterState,
	CDIFilterStateWithFeatureFilters,
} from "../../types/CDIFilter";
import {
	getLastDesignItemPopularityFilter,
	getLastDesignItemConnectorFilter,
	getLastDesignItemFeatureFilter,
	getLastDesignItemSearchFilter,
	getLastDesignItemSortPreference,
} from "../../services/lastDesignItemSearchFilter";
import { takeLastSearchFilter } from "../../utils/RouteConstants";

export const getLocalStorageDesignItemsSearchFilter = () => {
	const lastSearchFilter = getLastDesignItemSearchFilter();
	
	if (lastSearchFilter !== null) {
		return {
			members: lastSearchFilter.members,
			searchQuery: lastSearchFilter.searchQuery,
		};
	}
	return {
		members: [],
		searchQuery: undefined,
	};
};

export const getLastFeatureFilterIfRedirectedFromLogin = (searchParams: URLSearchParams) => {
	const isTakenLastFeatureFilter = searchParams.get(takeLastSearchFilter) === "true";
	
	return isTakenLastFeatureFilter ? getLastDesignItemFeatureFilter() : null;
};

export const getLastConnectorFilterIfRedirectedFromLogin = (searchParams: URLSearchParams) => {
	const isTakenLastConnectorFilter = searchParams.get(takeLastSearchFilter) === "true";
	
	return isTakenLastConnectorFilter ? getLastDesignItemConnectorFilter() : null;
};

export const getLastPopularityFilterIfRedirectedFromLogin = (searchParams: URLSearchParams) => {
	const isTakenLastPopularityFilter = searchParams.get(takeLastSearchFilter) === "true";
	
	return isTakenLastPopularityFilter ? getLastDesignItemPopularityFilter() : null;
};

export const getLastSortPreferenceIfRedirectedFromLogin = (searchParams: URLSearchParams) => {
	const isTakenLastSortPreference = searchParams.get(takeLastSearchFilter) === "true";
	
	return isTakenLastSortPreference ? getLastDesignItemSortPreference() : null;
};

export const getDesignItemSearchFilterFromLocationStateOrLocalStorage = (state: CDIFilterState | CDIFilterStateWithFeatureFilters) => {
	if (state && !("featureFilters" in state)) {
		return state as CDIFilterState;
	} else if (state && "featureFilters" in state) {
		return state.searchFilter as CDIFilterState;
	} else {
		return getLocalStorageDesignItemsSearchFilter();
	}
};

